export enum InstallationTypeCode {
  newConstruction = 'newConstruction',
  replacedHeatPump = 'replacedHeatPump',
  otherHeatSource = 'otherHeatSource'
}

export const INSTALLATION_TYPE = [
  { code: InstallationTypeCode.newConstruction },
  { code: InstallationTypeCode.replacedHeatPump },
  { code: InstallationTypeCode.otherHeatSource }
] as const;
